var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-checkbox',{on:{"change":_vm.updated},model:{value:(_vm.isChecked),callback:function ($$v) {_vm.isChecked=$$v},expression:"isChecked"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }